"use strict";

import "core-js/modules/web.dom-collections.iterator.js";
import { cssLinks } from "@ttark/css-links";
import { ReportBody } from "./body";
import { LegalRemixPage } from "~/components/legal-remix-page";
import { Fragment, jsx } from "react/jsx-runtime";
var links = () => [...cssLinks("routes/h5.feoffline.report.email-verify.input")];
var ReportInputPage = class extends LegalRemixPage {
  constructor() {
    super(...arguments);
    this.Head = () => /* @__PURE__ */jsx(Fragment, {});
    this.Body = () => /* @__PURE__ */jsx(ReportBody, {});
    this.useRouteLoading = () => false;
  }
};
export { ReportInputPage as default, links };